import styles from './Map.module.css';

export default function Map() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.preTitle}>
          <div className={styles.line}></div>
          <span>Localização</span>
          <div className={styles.line}></div>
        </div>
        <h1 className={styles.title}>Mapa Turístico</h1>
        <p className={styles.subtitle}>Explore os pontos turísticos e culturais de São José do Egito no mapa abaixo.</p>
      </div>
      <div className={styles.mapContainer}>
        <iframe 
          src="https://www.google.com/maps/d/embed?mid=1Y35Nn-FrHrGu_0J5RZ-muNQlAms3pSs&ehbc=2E312F" 
          title='Mapa do ponto turístico' 
          width="100%" 
          height="100%"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}